import { RpcService } from 'rpc';

export interface ISearchSvc extends RpcService {
	keyword_search(params: { find: string; version: string; language: string }): Promise<string[]>;
	topics_for_keyword(params: { keyword: string; version: string; language: string }): Promise<string[]>;
	related_topics(params: { topicid: string; versions: string; language: string }): Promise<string[]>;
}

export const svc: ISearchSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,

	services: {
		keyword_search: {
			parameters: [
				{
					name: 'find',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		topics_for_keyword: {
			parameters: [
				{
					name: 'keyword',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		},
		related_topics: {
			parameters: [
				{
					name: 'topicid',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		}
	}
}) as ISearchSvc;

export default svc;
